import LazyIconsCache from 'OK/LazyIconsCache';

export function getIcon(name: string, modificator = '', size = '') {

    const cache = LazyIconsCache.getInstance(name);
    const _size = size ? size : cache.getIconSize();
    const className = `svg-ic svg-${cache.getIconName()} svg-ic${_size} ${modificator}`;

    if (cache && cache.html) {
        try {
            const iconData = cache.getIconData()!;
            return `<svg class="${className}" viewBox="${iconData.viewBox}">${iconData.content}</svg>`;
        } catch (e) {
            return `<svg class="${className}"></svg>`;
        }
    } else {
        cache.load();
        return `<svg class="${className} h-mod" data-module="LazyIconNative" data-icon="${name}"></svg>`;
    }
}

export class LazyIconNative {
    private el!: SVGElement;
    private cache: LazyIconsCache | null = null;
    private loaded = false;

    activate(el: SVGElement) {
        const name = el.getAttribute('data-icon')!;

        this.el = el;
        this.cache = LazyIconsCache.getInstance(name);

        if (this.cache && this.cache.html) {
            this.onLoad();
        } else {
            this.cache.addListener(this.onLoad);
            this.cache.load();
        }
    }

    deactivate() {
        if (!this.loaded) {
            this.cache?.removeListener(this.onLoad);
        }
        this.cache = null;
    }

    onLoad = () => {
        applyContent(this.el, this.cache!);
        this.loaded = true;
    };
}

export function applyContent(svg: SVGElement, cache: LazyIconsCache) {
    svg.setAttribute('viewBox', cache.getIconData()!.viewBox);
    while (svg.firstChild) {
        svg.removeChild(svg.firstChild);
    }
    Array.from(cache.clone().childNodes).forEach(el => {
        svg.appendChild(el);
    });
}

export default LazyIconNative;
